import { RootState } from "../../store/store";

export const selectResult = (state: RootState) => state.scheduledJobExecutionDetails.result;
export const selectLoading = (state: RootState) => state.scheduledJobExecutionDetails.loading;
export const selectError = (state: RootState) => state.scheduledJobExecutionDetails.error;
export const selectErrorMessage = (state: RootState) => state.scheduledJobExecutionDetails.errorMessage;
